import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation } from 'react-router-dom';

import AppTopbar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import AppRightMenu from './AppRightMenu';
import AppBreadcrumb from './AppBreadcrumb';
import AppMenu from './AppMenu';

import Dashboard from './components/Dashboard';
import FormLayoutDemo from './components/FormLayoutDemo';
import InputDemo from './components/InputDemo';
import FloatLabelDemo from './components/FloatLabelDemo';
import InvalidStateDemo from './components/InvalidStateDemo';
import ButtonDemo from './components/ButtonDemo';
import TableDemo from './components/TableDemo';
import TableBarrios from './components/TableBarrios';
import TableBarrios2 from './components/TableBarrios2';
import ListDemo from './components/ListDemo';
import TreeDemo from './components/TreeDemo';
import PanelDemo from './components/PanelDemo';
import OverlayDemo from './components/OverlayDemo';
import MediaDemo from './components/MediaDemo';
import MenuDemo from './components/MenuDemo';
import MessagesDemo from './components/MessagesDemo';
import FileDemo from './components/FileDemo';
import ChartDemo from './components/ChartDemo';
import MiscDemo from './components/MiscDemo';
import Documentation from './components/Documentation';
import IconsDemo from './utilities/IconsDemo';
import CrudDemo from './pages/CrudDemo';
import CalendarDemo from './pages/CalendarDemo';
import TimelineDemo from './pages/TimelineDemo';
import Invoice from './pages/Invoice';
import Help from './pages/Help';
import EmptyPage from './pages/EmptyPage';
import HomePage from './pages/Home';
import BlocksDemo from './components/BlocksDemo';

import PrimeReact from 'primereact/api';
import { useTerminologia } from './hooks/useTerminologia';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import Persona from './pages/Persona';
import UnidadFuncional from './pages/UnidadFuncional';
import Gastos from './pages/Gastos'
import Gastos2 from './pages/Gastos2'
import PagoProveedores from './pages/PagoProveedores'
import Expensas from './pages/Expensas'
import CargoPeriodoUnidadFuncional from './pages/CargoPeriodoUnidadFuncional'
import FondoPorBarrio from './pages/FondoPorBarrio'
import Fondos from './pages/Fondos'
import TipoGasto from './pages/TipoGasto'
import ConfiguracionMails from './pages/ConfiguracionMails'
import GrupoGasto from './pages/GrupoGasto'
import CondicionIVA from './pages/CondicionIVA'
import Proveedores from './pages/Proveedores'
import GastoUnidadFuncional from './pages/GastoUnidadFuncional'
import SentenciaJudicialUnidadFuncional from './pages/SentenciaJudicialUnidadFuncional'
import PlanPago from './pages/PlanPago'
import Morosidad from './pages/Morosidad'
import EstadoCuentaAdmin from './pages/EstadoCuentaAdmin'
import Intereses from './pages/Intereses'
import ChequeoProveedores from './pages/ChequeoProveedores'
import ChequeoProveedoresModal from './components/ChequeoProveedoresModal'
import FormularioPago from './pages/FormularioPago'
import EstadoFinancieroConceptos from './pages/EstadoFinancieroConceptos'
import EstadoFinancieroValoresMensuales from './pages/EstadoFinancieroValoresMensuales'
import EstadoFinancieroResumen from './pages/EstadoFinancieroResumen'
import TasasMunicipales from './pages/TasasMunicipales'
import Coeficientes from './pages/Coeficientes'
import LiquidacionMensualAdministradoras from './pages/LiquidacionMensualAdministradoras';
import PermisosMenuPerfilAdministrador from './pages/PermisosMenuPerfilAdministrador';
import Administradoras from './pages/Administradoras';
import UsuariosAdministradoras from './pages/UsuariosAdministradoras';
import { ROL_SUPERADMIN, ROL_PERFIL_ADMINISTRADOR } from './constants/roles';
import { getMenuAdminDefinition } from './constants/menuAdminDefinition';
import { PermisosMenuProvider, usePermisosMenu } from './components/PermisosMenuContext';
import { AdministracionMenuProvider, useAdministracionMenu } from './components/AdministracionMenuContext';
import { BarrioProvider } from "./components/BarrioContext";
import { AuthProvider } from "./components/AuthContext";
import { ModulosProvider, useModulos } from "./components/ModulosContext";
import PortalBarrio from './pages/PortalBarrio';
import PortalBarrio2 from './pages/PortalBarrio2';
import GastosConsorcio from './pages/GastosConsorcio';
import GestionUsuarios from './pages/GestionUsuarios';
import Comunicados from './pages/Comunicados';
import ComunicadosBarrio from './pages/ComunicadosBarrio';
import SubirComprobante from './pages/SubirComprobante';
import Salones from './pages/Salones';
import ReservarSum from './pages/ReservarSum';
import ReservasSUMAdmin from './pages/ReservasSUMAdmin';
import ConfiguracionMantenimiento from './pages/ConfiguracionMantenimiento';
import MantenimientoAdmin from './pages/MantenimientoAdmin';
import Reclamos from './pages/Reclamos';
import ReclamosAdmin from './pages/ReclamosAdmin';
import OrdenesTrabajoAdmin from './pages/OrdenesTrabajoAdmin';
import InfraccionesAdmin from './pages/InfraccionesAdmin';
import InfraccionesBarrio from './pages/InfraccionesBarrio';
import TiposReclamo from './pages/TiposReclamo';
import Materiales from './pages/Materiales';
import TipoPersona from './pages/TipoPersona';
import TipoRelacionPersona from './pages/TipoRelacionPersona';
import Visitas from './pages/Visitas';
import VisitasAdmin from './pages/VisitasAdmin';
import VisitantesFrecuentes from './pages/VisitantesFrecuentes';
import TipoVisita from './pages/TipoVisita';
import TipoVehiculo from './pages/TipoVehiculo';
import OrigenEnvio from './pages/OrigenEnvio';
import Paquetes from './pages/Paquetes';
import PaquetesAdmin from './pages/PaquetesAdmin';
import MisPaquetes from './pages/MisPaquetes';
import DashboardPortero from './pages/DashboardPortero';
import PersonasPortero from './pages/PersonasPortero';
import ControlAcceso from './pages/ControlAcceso';
import EstadoCuenta from './pages/EstadoCuenta';
import DashboardGeneral from './pages/DashboardGeneral';
import ExpensasBarrio from './pages/ExpensasBarrio';
import ChatWidget from './components/ChatWidget';
import ComunidadAsambleasAdmin from './pages/ComunidadAsambleasAdmin';
import ComunidadConsejoAdmin from './pages/ComunidadConsejoAdmin';
import ComunidadActasAdmin from './pages/ComunidadActasAdmin';
import ComunidadDocumentosAdmin from './pages/ComunidadDocumentosAdmin';
import ComunidadDocumentosBarrio from './pages/ComunidadDocumentosBarrio';
import { PersonaResidenteProvider, usePersonaResidente } from './components/PersonaResidenteContext';

const App = (props) => (
    <AuthProvider>
        <ModulosProvider>
            <PermisosMenuProvider>
                <AdministracionMenuProvider>
                    <BarrioProvider>
                        <PersonaResidenteProvider>
                            <AppInner {...props} />
                        </PersonaResidenteProvider>
                    </BarrioProvider>
                </AdministracionMenuProvider>
            </PermisosMenuProvider>
        </ModulosProvider>
    </AuthProvider>
);

const AppInner = (props) => {
    const { modulos } = useModulos();
    const { menuOcultos } = usePermisosMenu();
    const { menuOcultosAdministracion } = useAdministracionMenu();
    const { asambleaHabilitada } = usePersonaResidente();
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [menuMode, setMenuMode] = useState('overlay');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [ripple, setRipple] = useState(true);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(false);
    const [pinActive, setPinActive] = useState(false);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState(null);
    const copyTooltipRef = useRef();
    const location = useLocation();

    PrimeReact.ripple = true;

    const rolId = parseInt(localStorage.getItem('rolId') || '1');
    const esPortero = rolId === 3;
    const esUsuarioBarrio = rolId === 2;
    const esSuperadmin = rolId === ROL_SUPERADMIN;
    const esPerfilAdministrador = rolId === ROL_PERFIL_ADMINISTRADOR;
    const t = useTerminologia();

    const menuSuperadmin = [
        { label: 'Liquidación Mensual', icon: 'pi pi-dollar', to: '/liquidacionMensual' },
        { label: 'Administradoras', icon: 'pi pi-building', to: '/administradoras' },
        { label: 'Usuarios Administradoras', icon: 'pi pi-users', to: '/usuariosAdministradoras' },
    ];

    const menuPortero = [
        { label: 'Dashboard', icon: 'pi pi-chart-bar', to: '/dashboardPortero' },
        { label: 'Paquetes', icon: 'pi pi-box', to: '/paquetes', modulo: 'modPaquetes' },
        { label: 'Control de Acceso', icon: 'pi pi-car', to: '/controlAcceso', modulo: 'modVisitas' },
        { label: 'Visitas (detalle)', icon: 'pi pi-table', to: '/visitasAdmin', modulo: 'modVisitas' },
        { label: 'Visitantes Frecuentes', icon: 'pi pi-id-card', to: '/visitantesFrecuentes', modulo: 'modVisitas' },
        { label: 'Registro de Rostros', icon: 'pi pi-id-card', to: '/personasPortero' },
    ];

    const menuUsuarioBarrio = [
        { label: 'Dashboard', icon: 'pi pi-chart-bar', to: '/portal' },
        { label: 'Estado de Cuenta', icon: 'pi pi-file', to: '/estadoCuenta' },
        { label: 'Gastos Consorcio', icon: 'pi pi-chart-pie', to: '/gastosConsorcio' },
        { label: 'Expensas', icon: 'pi pi-file-pdf', to: '/expensasBarrio', modulo: 'modExpensas' },
        { label: 'Comunicados', icon: 'pi pi-megaphone', to: '/comunicadosBarrio', modulo: 'modComunicados' },
        { label: 'Pagos', icon: 'pi pi-upload', to: '/subirComprobante', modulo: 'modPagos' },
        { label: 'Reservas', icon: 'pi pi-calendar-plus', to: '/reservarSum', modulo: 'modReservas' },
        { label: 'Reclamos', icon: 'pi pi-flag', to: '/reclamos', modulo: 'modReclamos' },
        { label: 'Infracciones', icon: 'pi pi-exclamation-triangle', to: '/infraccionesBarrio' },
        { label: 'Avisar Visita', icon: 'pi pi-car', to: '/visitas', modulo: 'modVisitas' },
        { label: 'Mis Paquetes', icon: 'pi pi-inbox', to: '/misPaquetes', modulo: 'modPaquetes' },
        {
            label: 'Comunidad',
            icon: 'pi pi-users',
            visible: () => asambleaHabilitada,
            items: [
                { label: 'Asambleas', icon: 'pi pi-calendar', to: '/comunidadAsambleasBarrio' },
                { label: 'Consejo', icon: 'pi pi-sitemap', to: '/comunidadConsejoBarrio' },
                { label: 'Actas', icon: 'pi pi-file', to: '/comunidadActasBarrio' },
                { label: 'Documentos', icon: 'pi pi-folder', to: '/comunidadDocumentosBarrio' },
            ],
        },
    ];

    const menuAdmin = getMenuAdminDefinition(t);

    const filtrarPorModulos = (items) =>
        items
            .filter((item) => !item.modulo || modulos[item.modulo] !== false)
            .map((item) => (item.items ? { ...item, items: filtrarPorModulos(item.items) } : item))
            .filter((item) => !item.items || item.items.length > 0);

    // Filtro generico por clave de menu (el `to` de cada hoja, sin la barra inicial).
    // Lo usan tanto los permisos que el Administrador define para el Perfil Administrador
    // como los menus que el Superadmin habilita/deshabilita para toda la administradora.
    const filtrarPorClaves = (items, clavesOcultas) =>
        items
            .filter((item) => !item.to || !clavesOcultas.includes(item.to.replace(/^\//, '')))
            .map((item) => (item.items ? { ...item, items: filtrarPorClaves(item.items, clavesOcultas) } : item))
            .filter((item) => !item.items || item.items.length > 0);

    // La pantalla de permisos siempre queda fuera del alcance del Perfil Administrador,
    // para que no pueda reconfigurar sus propios permisos.
    const RESTRINGIDOS_PERFIL_ADMINISTRADOR = ['permisosMenuPerfilAdministrador'];

    let menu = filtrarPorModulos(esSuperadmin ? menuSuperadmin : esPortero ? menuPortero : esUsuarioBarrio ? menuUsuarioBarrio : menuAdmin);
    // Lo que el Superadmin deshabilito para esta administradora aplica a Administrador y Perfil Administrador.
    if (!esSuperadmin && !esPortero && !esUsuarioBarrio) menu = filtrarPorClaves(menu, menuOcultosAdministracion);
    if (esPerfilAdministrador) menu = filtrarPorClaves(menu, [...menuOcultos, ...RESTRINGIDOS_PERFIL_ADMINISTRADOR]);

    const routes = [
        { parent: 'Dashboard', label: 'Sales Dashboard' },
        { parent: 'UI Kit', label: 'Form Layout' },
        { parent: 'UI Kit', label: 'Input' },
        { parent: 'UI Kit', label: 'Float Label' },
        { parent: 'UI Kit', label: 'Invalid State' },
        { parent: 'UI Kit', label: 'Button' },
        { parent: 'UI Kit', label: 'Table' },
        { parent: 'UI Kit', label: 'List' },
        { parent: 'UI Kit', label: 'Panel' },
        { parent: 'UI Kit', label: 'Tree' },
        { parent: 'UI Kit', label: 'Overlay' },
        { parent: 'UI Kit', label: 'Menu' },
        { parent: 'UI Kit', label: 'Media' },
        { parent: 'UI Kit', label: 'Message' },
        { parent: 'UI Kit', label: 'File' },
        { parent: 'UI Kit', label: 'Chart' },
        { parent: 'UI Kit', label: 'Misc' },
        { parent: 'UI Blocks', label: 'Blocks' },
        { parent: 'Utilities', label: 'Icons' },
        { parent: 'Pages', label: 'Crud' },
        { parent: 'Pages', label: 'Calendar' },
        { parent: 'Pages', label: 'Timeline' },
        { parent: 'Pages', label: 'Invoice' },
        { parent: 'Pages', label: 'Login' },
        { parent: 'Pages', label: 'Help' },
        { parent: 'Pages', label: 'Empty' },
        { parent: 'Pages', label: 'Home' },
        { parent: 'Pages', label: 'Access' },
        { parent: 'Start', label: 'Documentation' }
    ];

    let rightMenuClick;
    let configClick;
    let menuClick;
    let searchClick = false;
    let topbarItemClick;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        topbarItemClick = false;
        menuClick = false;
        configClick = false;
        rightMenuClick = false;
        searchClick = false;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onMenuModeChange = (menuMode) => {
        setMenuMode(menuMode);
        setOverlayMenuActive(false);
    };

    const onRightMenuButtonClick = () => {
        rightMenuClick = true;
        setRightMenuActive(true);
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuActiveChange = (active) => {
        setRightMenuActive(active);
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = (event) => {
        setConfigActive((prevState) => !prevState);
        configClick = true;
        event.preventDefault();
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onToggleMenu = (event) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event) => {
        setActiveInlineProfile((prevState) => !prevState);
        event.preventDefault();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const onInputClick = () => {
        searchClick = true;
    };

    const breadcrumbClick = () => {
        searchClick = true;
        setSearchActive(true);
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
        'p-ripple-disabled': !ripple
    });

    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            <div className="layout-main">
                <AppTopbar
                    items={menu}
                    menuMode={menuMode}
                    colorScheme={props.colorScheme}
                    menuActive={menuActive}
                    topbarMenuActive={topbarMenuActive}
                    activeInlineProfile={activeInlineProfile}
                    onTopbarItemClick={onTopbarItemClick}
                    onMenuButtonClick={onMenuButtonClick}
                    onSidebarMouseOver={onSidebarMouseOver}
                    onSidebarMouseLeave={onSidebarMouseLeave}
                    onToggleMenu={onToggleMenu}
                    onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                    onMenuClick={onMenuClick}
                    onMenuItemClick={onMenuItemClick}
                    onRootMenuItemClick={onRootMenuItemClick}
                    resetActiveIndex={resetActiveIndex}
                />

                <AppMenu
                    model={menu}
                    onRootMenuItemClick={onRootMenuItemClick}
                    onMenuItemClick={onMenuItemClick}
                    onToggleMenu={onToggleMenu}
                    onMenuClick={onMenuClick}
                    menuMode={menuMode}
                    colorScheme={props.colorScheme}
                    menuActive={menuActive}
                    sidebarActive={sidebarActive}
                    sidebarStatic={sidebarStatic}
                    pinActive={pinActive}
                    onSidebarMouseLeave={onSidebarMouseLeave}
                    onSidebarMouseOver={onSidebarMouseOver}
                    activeInlineProfile={activeInlineProfile}
                    onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                    resetActiveIndex={resetActiveIndex}
                />

                {/* <AppBreadcrumb routes={routes} onMenuButtonClick={onMenuButtonClick} menuMode={menuMode} onRightMenuButtonClick={onRightMenuButtonClick} onInputClick={onInputClick} searchActive={searchActive} breadcrumbClick={breadcrumbClick} /> */}

                <div className="layout-main-content">
                    <Routes>
                        <Route path="/" exact="true" element={<Dashboard />} />
                        <Route path="/dashboardGeneral" element={<DashboardGeneral />} />
                        <Route path="/portal" element={<PortalBarrio />} />
                        <Route path="/portal2" element={<PortalBarrio2 />} />
                        <Route path="/gestionUsuarios" element={<GestionUsuarios />} />
                        <Route path="/documentation" element={<Documentation />} />
                        <Route path="/formlayout" element={<FormLayoutDemo />} />
                        <Route path="/floatlabel" element={<FloatLabelDemo />} />
                        <Route path="/input" element={<InputDemo />} />
                        <Route path="/invalidstate" element={<InvalidStateDemo />} />
                        <Route path="/button" element={<ButtonDemo />} />
                        <Route path="/table" element={<TableDemo />} />
                        <Route path="/tableBarrios" element={<TableBarrios />} />
                        <Route path="/tableBarrios2" element={<TableBarrios2 />} />
                        <Route path="/liquidacionMensual" element={<LiquidacionMensualAdministradoras />} />
                        <Route path="/administradoras" element={<Administradoras />} />
                        <Route path="/usuariosAdministradoras" element={<UsuariosAdministradoras />} />
                        <Route path="/list" element={<ListDemo />} />
                        <Route path="/tree" element={<TreeDemo />} />
                        <Route path="/panel" element={<PanelDemo />} />
                        <Route path="/overlay" element={<OverlayDemo />} />
                        <Route path="/menu/*" element={<MenuDemo />} />
                        <Route path="/message" element={<MessagesDemo />} />
                        <Route path="/media" element={<MediaDemo />} />
                        <Route path="/file" element={<FileDemo />} />
                        <Route path="/chart" element={<ChartDemo colorMode={props.colorScheme} location={location} />} />
                        <Route path="/misc" element={<MiscDemo />} />
                        <Route path="/blocks" element={<BlocksDemo />} />
                        <Route path="/icons" element={<IconsDemo />} />
                        <Route path="/crud" element={<CrudDemo />} />
                        <Route path="/calendar" element={<CalendarDemo />} />
                        <Route path="/help" element={<Help />} />
                        <Route path="/invoice" element={<Invoice colorMode={props.colorScheme} location={location} />} />
                        <Route path="/empty" element={<EmptyPage />} />
                        <Route path="/home" element={<HomePage />} />
                        <Route path="/timeline" element={<TimelineDemo />} />
                        <Route path="/persona" element={<Persona />} />
                        <Route path="/unidadFuncional" element={<UnidadFuncional />} />
                        <Route path="/gastos" element={<Gastos />} />
                        <Route path="/gastos2" element={<Gastos2 />} />
                        <Route path="/pagoProveedores" element={<PagoProveedores />} />
                        <Route path="/expensas" element={<Expensas />} />
                        <Route path="/cargoPeriodoUnidadFuncional" element={<CargoPeriodoUnidadFuncional />} />
                        <Route path="/gastoUnidadFuncional" element={<GastoUnidadFuncional />} />
                        <Route path="/fondos" element={<Fondos />} />
                        <Route path="/tipoGasto" element={<TipoGasto />} />
                        <Route path="/configuracionMails" element={<ConfiguracionMails />} />
                        <Route path="/permisosMenuPerfilAdministrador" element={<PermisosMenuPerfilAdministrador />} />
                        <Route path="/grupoGasto" element={<GrupoGasto />} />
                        <Route path="/condicionIVA" element={<CondicionIVA />} />
                        <Route path="/proveedores" element={<Proveedores />} />
                        <Route path="/sentenciaJudicialUnidadFuncional" element={<SentenciaJudicialUnidadFuncional />} />
                        <Route path="/planPago" element={<PlanPago />} />
                        <Route path="/morosidad" element={<Morosidad />} />
                        <Route path="/estadoCuentaAdmin" element={<EstadoCuentaAdmin />} />
                        <Route path="/intereses" element={<Intereses />} />
                        <Route path="/chequeoProveedores" element={<ChequeoProveedores />} />
                        <Route path="/formularioPago" element={<FormularioPago />} />
                        <Route path="/estadoFinancieroConceptos" element={<EstadoFinancieroConceptos />} />
                        <Route path="/estadoFinancieroValoresMensuales" element={<EstadoFinancieroValoresMensuales />} />
                        <Route path="/estadoFinancieroResumen" element={<EstadoFinancieroResumen />} />
                        <Route path="/comunidadAsambleas" element={<ComunidadAsambleasAdmin />} />
                        <Route path="/comunidadConsejo" element={<ComunidadConsejoAdmin />} />
                        <Route path="/comunidadActas" element={<ComunidadActasAdmin />} />
                        <Route path="/comunidadDocumentos" element={<ComunidadDocumentosAdmin />} />
                        <Route path="/comunidadAsambleasBarrio" element={<ComunidadAsambleasAdmin />} />
                        <Route path="/comunidadConsejoBarrio" element={<ComunidadConsejoAdmin />} />
                        <Route path="/comunidadActasBarrio" element={<ComunidadActasAdmin />} />
                        <Route path="/comunidadDocumentosBarrio" element={<ComunidadDocumentosBarrio />} />
                        <Route path="/tasasMunicipales" element={<TasasMunicipales />} />
                        <Route path="/coeficientes" element={<Coeficientes />} />
                        <Route path="/salones" element={<Salones />} />
                        <Route path="/configuracionMantenimiento" element={<ConfiguracionMantenimiento />} />
                        <Route path="/mantenimientoAdmin" element={<MantenimientoAdmin />} />
                        <Route path="/comunicados" element={<Comunicados />} />
                        <Route path="/comunicadosBarrio" element={<ComunicadosBarrio />} />
                        <Route path="/subirComprobante" element={<SubirComprobante />} />
                        <Route path="/reservarSum" element={<ReservarSum />} />
                        <Route path="/reservasSUMAdmin" element={<ReservasSUMAdmin />} />
                        <Route path="/reclamos" element={<Reclamos />} />
                        <Route path="/reclamosAdmin" element={<ReclamosAdmin />} />
                        <Route path="/ordenesTrabajoAdmin" element={<OrdenesTrabajoAdmin />} />
                        <Route path="/infraccionesAdmin" element={<InfraccionesAdmin />} />
                        <Route path="/infraccionesBarrio" element={<InfraccionesBarrio />} />
                        <Route path="/tiposReclamo" element={<TiposReclamo />} />
                        <Route path="/materiales" element={<Materiales />} />
                        <Route path="/tipoPersona" element={<TipoPersona />} />
                        <Route path="/tipoRelacionPersona" element={<TipoRelacionPersona />} />
                        <Route path="/visitas" element={<Visitas />} />
                        <Route path="/visitasAdmin" element={<VisitasAdmin />} />
                        <Route path="/visitantesFrecuentes" element={<VisitantesFrecuentes />} />
                        <Route path="/tipoVisita" element={<TipoVisita />} />
                        <Route path="/tipoVehiculo" element={<TipoVehiculo />} />
                        <Route path="/origenEnvio" element={<OrigenEnvio />} />
                        <Route path="/paquetes" element={<Paquetes />} />
                        <Route path="/paquetesAdmin" element={<PaquetesAdmin />} />
                        <Route path="/misPaquetes" element={<MisPaquetes />} />
                        <Route path="/dashboardPortero" element={<DashboardPortero />} />
                        <Route path="/personasPortero" element={<PersonasPortero />} />
                        <Route path="/controlAcceso" element={<ControlAcceso />} />
                        <Route path="/estadoCuenta" element={<EstadoCuenta />} />
                        <Route path="/gastosConsorcio" element={<GastosConsorcio />} />
                        <Route path="/expensasBarrio" element={<ExpensasBarrio />} />
                    </Routes>
                </div>

                <AppFooter colorScheme={props.colorScheme} />
            </div>

            <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick} onRightMenuActiveChange={onRightMenuActiveChange} />

            <AppConfig
                configActive={configActive}
                onConfigButtonClick={onConfigButtonClick}
                onConfigClick={onConfigClick}
                menuMode={menuMode}
                changeMenuMode={onMenuModeChange}
                colorScheme={props.colorScheme}
                changeColorScheme={props.onColorSchemeChange}
                theme={props.theme}
                changeTheme={props.onMenuThemeChange}
                componentTheme={props.componentTheme}
                changeComponentTheme={props.onComponentThemeChange}
                ripple={ripple}
                onRippleChange={onRippleChange}
            />

            <ChatWidget />
            <ChequeoProveedoresModal />
        </div>
    );
};

export default App;
